/**
 * CTS Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import BookListIsCheckedDto from './BookListIsCheckedDto';
import PaginationModel from './PaginationModel';

/**
 * The BookListIsCheckedWithPaginationDto model module.
 * @module model/BookListIsCheckedWithPaginationDto
 * @version v1.0.0
 */
class BookListIsCheckedWithPaginationDto {
    /**
     * Constructs a new <code>BookListIsCheckedWithPaginationDto</code>.
     * @alias module:model/BookListIsCheckedWithPaginationDto
     */
    constructor() { 
        
        BookListIsCheckedWithPaginationDto.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>BookListIsCheckedWithPaginationDto</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/BookListIsCheckedWithPaginationDto} obj Optional instance to populate.
     * @return {module:model/BookListIsCheckedWithPaginationDto} The populated <code>BookListIsCheckedWithPaginationDto</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new BookListIsCheckedWithPaginationDto();

            if (data.hasOwnProperty('pagination')) {
                obj['pagination'] = PaginationModel.constructFromObject(data['pagination']);
            }
            if (data.hasOwnProperty('result')) {
                obj['result'] = ApiClient.convertToType(data['result'], [BookListIsCheckedDto]);
            }
        }
        return obj;
    }


}

/**
 * @member {module:model/PaginationModel} pagination
 */
BookListIsCheckedWithPaginationDto.prototype['pagination'] = undefined;

/**
 * @member {Array.<module:model/BookListIsCheckedDto>} result
 */
BookListIsCheckedWithPaginationDto.prototype['result'] = undefined;






export default BookListIsCheckedWithPaginationDto;

